export const tokenMixin = {
  methods: {
    checkForToken () {
      console.log('checkForToken');
      if (this.$localStorage.get('token') == null)
      {
        this.$router.replace('/login');
        return false;
      }
      var expirationDate = this.$localStorage.get('tokenExpiration');
      if (expirationDate === null)
      {
        this.$router.replace('/login');
        return false;
      }
      else {
        var expirationDateToDate = new Date(expirationDate);
        var currentDate = new Date();
        if (expirationDateToDate < currentDate)
        {
          this.$router.replace('/login');
          return false;
        }
      }
      return true;
    },
    checkForNav () {
    if (this.$localStorage.get('navleft') == null) {
        return false;
    }
    else {
      return true;
    }
    },
    buildTokenHeader () {
      return {
        headers: {'Authorization': 'bearer ' + this.$localStorage.get('token')}
      };
    }
  }
}
